import React from "react";
import { Link } from "react-router-dom";
import clouds from "../../assets/images/NotFound.jpg";
import "../Error.scss";

export const NotFound: React.FC = () => (
    <main
        className="page"
        style={ {
            backgroundImage: `url(${ clouds }`
        } }
    >
        <h1>404</h1>
        <h2>Page not found</h2>
        <p>The page you were looking for does not exist</p>
        <Link to="/" className="link">
            Back to home
        </Link>
    </main>
);

export default NotFound;